import type { CSSProperties } from 'react';

import { TextMeasureHelper } from '../layout';

// The hairline is an inset shadow so it takes no width from the text the layout measured.
export const connectorLabelStyle: CSSProperties = {
  position: 'absolute',
  boxSizing: 'border-box',
  margin: 0,
  padding: '2px 6px',
  border: 'none',
  borderRadius: 'var(--pf-radius-sm)',
  background: 'var(--pf-color-background)',
  boxShadow: 'inset 0 0 0 0.5px var(--pf-color-soft-pearl-400)',
  font: TextMeasureHelper.LABEL_FONT,
  lineHeight: '17px',
  textAlign: 'left',
  color: 'var(--pf-color-soft-pearl-800)',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const highlightedConnectorLabelStyle: CSSProperties = {
  ...connectorLabelStyle,
  boxShadow: 'inset 0 0 0 0.5px var(--pf-color-soft-pearl-700)',
  color: 'var(--pf-color-soft-pearl-1000)',
};
